import {css} from 'styled-components';

import Utility from '../../../util/utilityfunctions';

const lightMode = css`
	--box-shadow: 0rem 0rem 0.8rem ${(props) => `${props.theme.color[`black`]}20`};
`;

const darkMode = css`
	--box-shadow: 0rem 0rem 0.8rem #00000050;
`;

export default css`
	--success-icon-encoded: url('data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.3143%2016.7694L18.576%208.50772L17.2762%207.16381L10.3143%2014.1477L7.05371%2010.8651L5.75386%2012.1649L10.3143%2016.7694ZM12.165%203C13.8394%203%2015.3889%203.41859%2016.8136%204.25578C18.1942%205.04891%2019.2811%206.13577%2020.0742%207.51641C20.9114%208.9411%2021.33%2010.4906%2021.33%2012.165C21.33%2013.8394%2020.9114%2015.3889%2020.0742%2016.8136C19.2811%2018.1942%2018.1942%2019.2811%2016.8136%2020.0742C15.3889%2020.9114%2013.8394%2021.33%2012.165%2021.33C10.4906%2021.33%208.9411%2020.9114%207.51641%2020.0742C6.13577%2019.2664%205.04891%2018.1722%204.25578%2016.7916C3.41859%2015.3669%203%2013.8247%203%2012.165C3%2010.5053%203.41859%208.96313%204.25578%207.53844C5.0636%206.15781%206.15781%205.0636%207.53844%204.25578C8.96313%203.41859%2010.5053%203%2012.165%203Z%22%20fill%3D%22%23168736%22%2F%3E%0A%3C%2Fsvg%3E%0A');
	--error-icon-encoded: url('data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.9697%203C7.91061%203%203.80469%207.10592%203.80469%2012.165C3.80469%2017.2241%207.91061%2021.33%2012.9697%2021.33C18.0288%2021.33%2022.1347%2017.2241%2022.1347%2012.165C22.1347%207.10592%2018.0288%203%2012.9697%203ZM13.8862%2016.7475H12.0532V14.9145H13.8862V16.7475ZM13.8862%2013.0815H12.0532V7.58251H13.8862V13.0815Z%22%20fill%3D%22%23B9251C%22%2F%3E%0A%3C%2Fsvg%3E%0A');
	${() => Utility.isDarkMode() ? darkMode : lightMode};
	--notification-size: 4.4rem;
	--border: none;
	--bg: ${(props) => props.theme.color[`white`]};
	--font-color: ${(props) => props.theme.color[`grey500`]};
	--padding: 1.2rem 1rem;

	.error-icon, .success-icon {
		height: var(--notification-size);
		width: var(--notification-size);
		background: none;
		background-color: transparent;
		background-repeat: no-repeat;
		background-size: 2.4rem;
		background-position: center;
	}
	.success-icon {
		background-image: var(--success-icon-encoded);
	}
	.error-icon {
		background-image: var(--error-icon-encoded);
	}
`;

export const toastFont = css`
	font-weight: 300;
`;

export const closeIcon = css`
	--size: 2rem;
	width: var(--size) !important;
	height: var(--size) !important;
	top: 50% !important;
	transform: translateY(-50%);
	right: 1.4rem !important;
`;
